const init = () => {
    // Wait for fonts to load before calculating line heights
    const waitForFonts = () => {
        return new Promise((resolve) => {
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(resolve);
            } else {
                // Fallback for browsers without font loading API
                setTimeout(resolve, 100);
            }
        });
    };

    const initializeFeatureBlocks = async () => {
        // Wait for fonts to be ready
        await waitForFonts();
        
        // Additional delay to ensure all styles are applied
        await new Promise(resolve => setTimeout(resolve, 50));
        
        const featureSliderItems = document.querySelectorAll('.c-feature-block__slide');
        
        // Handle image loading and fade-in
        const handleImageLoad = (img) => {
            img.classList.add('is-loaded');
        };
        
        // Set up image load listeners
        const images = document.querySelectorAll('.c-feature-block img, .c-feature-collection img');
        images.forEach((img) => {
            if (img.complete) {
                // Image already loaded
                handleImageLoad(img);
            } else {
                // Wait for image to load
                img.addEventListener('load', () => handleImageLoad(img));
                img.addEventListener('error', () => handleImageLoad(img)); // Fade in even on error
            }
        });

        // Function to get the line height of an element
        const getLineHeight = (element) => {
            const computedStyle = window.getComputedStyle(element);
            const lineHeight = parseFloat(computedStyle.lineHeight);
            const fontSize = parseFloat(computedStyle.fontSize);
            
            // If lineHeight is 'normal' or NaN, calculate it from font-size
            if (isNaN(lineHeight) || computedStyle.lineHeight === 'normal') {
                // Use a more accurate default line-height multiplier based on font size
                return fontSize * 1.4; // Increased from 1.2 to 1.4 for better accuracy
            }
            
            // Ensure we have a reasonable line height
            if (lineHeight < fontSize) {
                return fontSize * 1.4; // Minimum line height should be at least font size
            }
            
            return lineHeight;
        };

        // Function to adjust the description for each item
        const adjustDescription = (title, desc) => {
            const maxTotalLines = 3;

            // Skip if elements don't exist
            if (!title || !desc) {
                return;
            }

            // Calculate line heights
            const titleLineHeight = getLineHeight(title);
            const descLineHeight = getLineHeight(desc);

            // Skip if line heights are invalid
            if (isNaN(titleLineHeight) || isNaN(descLineHeight) || titleLineHeight <= 0 || descLineHeight <= 0) {
                console.warn('Invalid line heights detected:', { titleLineHeight, descLineHeight });
                return;
            }

            // Remove existing styles and classes in case of resizing
            title.style.webkitLineClamp = '';
            title.style.webkitBoxOrient = '';
            title.style.display = '';
            title.style.overflow = '';
            title.style.maxHeight = '';
            title.classList.remove('u-line-clamp');
            
            desc.style.webkitLineClamp = '';
            desc.style.webkitBoxOrient = '';
            desc.style.display = '';
            desc.style.overflow = '';
            desc.style.maxHeight = '';
            desc.classList.remove('u-line-clamp', 'none', 'is-visible');

            // Use a more reliable method to calculate title lines
            // Create a temporary clone for accurate measurement
            const tempTitle = title.cloneNode(true);
            tempTitle.style.position = 'absolute';
            tempTitle.style.visibility = 'hidden';
            tempTitle.style.height = 'auto';
            tempTitle.style.maxHeight = 'none';
            tempTitle.style.webkitLineClamp = 'none';
            tempTitle.style.webkitBoxOrient = '';
            tempTitle.style.display = 'block';
            tempTitle.style.overflow = 'visible';
            tempTitle.style.whiteSpace = 'normal';
            tempTitle.style.width = title.offsetWidth + 'px';
            
            // Copy all computed styles to ensure accurate measurement
            const computedStyle = window.getComputedStyle(title);
            tempTitle.style.fontSize = computedStyle.fontSize;
            tempTitle.style.fontFamily = computedStyle.fontFamily;
            tempTitle.style.fontWeight = computedStyle.fontWeight;
            tempTitle.style.lineHeight = computedStyle.lineHeight;
            tempTitle.style.letterSpacing = computedStyle.letterSpacing;
            tempTitle.style.wordSpacing = computedStyle.wordSpacing;
            tempTitle.style.padding = computedStyle.padding;
            tempTitle.style.margin = computedStyle.margin;
            tempTitle.style.border = computedStyle.border;
            tempTitle.style.boxSizing = computedStyle.boxSizing;
            
            // Add to DOM temporarily
            document.body.appendChild(tempTitle);
            
            // Calculate how many lines the title actually needs
            const titleHeight = tempTitle.offsetHeight;
            const titleLinesUsed = Math.ceil(titleHeight / titleLineHeight);
            
            // Remove temporary element
            document.body.removeChild(tempTitle);

            // NEW LOGIC: Prioritize titles - always show up to 3 lines of title
            const actualTitleLines = Math.min(titleLinesUsed, maxTotalLines);

            // Apply line-clamp to title with proper CSS properties
            title.style.display = '-webkit-box';
            title.style.webkitBoxOrient = 'vertical';
            title.style.overflow = 'hidden';
            title.style.webkitLineClamp = actualTitleLines;

            // Calculate remaining lines for description
            const remainingLines = maxTotalLines - actualTitleLines;

            if (remainingLines > 0) {
                // Show description with remaining lines
                desc.style.display = '-webkit-box';
                desc.style.webkitBoxOrient = 'vertical';
                desc.style.overflow = 'hidden';
                desc.style.webkitLineClamp = remainingLines;
                // Remove maxHeight constraint to let description flow naturally
                desc.style.maxHeight = '';
                
                // Fade in the description after a brief delay to ensure layout is stable
                requestAnimationFrame(() => {
                    desc.classList.add('is-visible');
                });
            } else {
                // Hide description if no lines remaining (title uses all 3 lines)
                desc.classList.add('none');
            }
        };

        // Loop through each slider item and adjust the description
        featureSliderItems.forEach((item) => {
            const title = item.querySelector('.c-feature-block__title');
            const desc = item.querySelector('.c-feature-block__desc');

            adjustDescription(title, desc);  // Adjust the description for this item
        });

        // Retry calculation after a short delay to catch any timing issues
        setTimeout(() => {
            featureSliderItems.forEach((item) => {
                const title = item.querySelector('.c-feature-block__title');
                const desc = item.querySelector('.c-feature-block__desc');

                // Only recalculate if description is hidden (might indicate calculation error)
                if (desc && desc.classList.contains('none')) {
                    adjustDescription(title, desc);
                }
            });
        }, 200);

        // Recalculate for each item on window resize
        window.addEventListener('resize', () => {
            featureSliderItems.forEach((item) => {
                const title = item.querySelector('.c-feature-block__title');
                const desc = item.querySelector('.c-feature-block__desc');

                // Remove visibility class before recalculating to prevent layout shift
                if (desc) {
                    desc.classList.remove('is-visible');
                }
                
                adjustDescription(title, desc);  // Adjust the description on resize
            });
        });
    };

    // Initialize when DOM is ready
    window.addEventListener('DOMContentLoaded', initializeFeatureBlocks);
};

export default init;
